/**
 * Choice lists for select / multi-select custom fields.
 *
 * An entry can hold a value that is no longer offered — e.g. an issue tag
 * from the template's defaults after the admin set the organization's own
 * list. The pickers only drew the offered options, so such a value stayed on
 * the entry, invisible and impossible to remove. These helpers keep it shown.
 */
type Option = { value: string; label?: string };

/** The offered options, followed by any stored value they do not include. */
export function withStoredValues(options: Option[] | undefined, stored: unknown): Option[] {
  const list = options || [];
  const values = Array.isArray(stored) ? stored : [];
  const offered = new Set(list.map(o => o.value));
  const extra = values
    .filter((v): v is string => typeof v === 'string' && v !== '' && !offered.has(v))
    .map(v => ({ value: v, label: v }));
  return extra.length ? [...list, ...extra] : list;
}

/** The name shown for a stored value ("ie/authority_observations" → "IE/Authority observations"). */
export function optionLabel(options: Option[] | undefined, value: string): string {
  const match = (options || []).find(o => o.value === value);
  return match?.label || value;
}
